/*
 * @Description: 封装axios
*/

import axios from 'axios'
import router from '../router'
import store from "@/store";
import Vue from 'vue'

import { getLang, i18n } from '@/locales/index';

import {
  Loading,
  MessageBox,
  Notification
} from "element-ui";

var loading;
let that = this;
let timer = null;
function startLoading() {
  timer = setTimeout(() => {
    loading = Loading.service({
      lock: true,
      text: i18n.t("header.loading"),
      spinner: "el-icon-loading",
      background: "rgba(0,0,0,0.7)"
    });
  }, 800);
}

let needLoadingRequestCount = 0;

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    needLoadingRequestCount == 0;
    return;
  }
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    if (loading) {
      loading.close();
    } else {
      clearTimeout(timer)
    }
  }
}

// axios 配置
axios.defaults.timeout = 30000
// axios.defaults.baseURL = 'https://www.x-pool.io/api/hashrate' //正式服务器
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.baseURL = 'http://192.168.2.48:28081/hashrate' //测试服务器

/**
 * @param  {string} url
 * @param  {object} data={}
 */
const url = {
  user: process.env.XPOOL_USER_API,
  pool: process.env.XPOOL_POOL_API,
  innovation: process.env.XPOOL_INNOVATION_API
}

// 请求拦截器
axios.interceptors.request.use(config => {
  const { headers } = config;
  // 接口认证配置
  if (headers["certificate"])
    headers["certificate"] = localStorage["certificate"];

  if (headers["json"])
    headers["Content-Type"] = 'application/json';

  if (headers["verify"]) headers["verify"] = sessionStorage["verify"];

  headers['lang'] = getLang();

  showFullScreenLoading();

  return config;
}, err => Promise.reject(err))


// error lock
let errorArr = [];

// 响应拦截器
axios.interceptors.response.use(response => {
  clearTimeout(timer)
  timer = null;

  const res = response.data;
  const pathUrl = response.config.url;
  if (pathUrl && pathUrl.indexOf("/user/getCode") > -1) {
    if (response.headers.verify) {
      sessionStorage["verify"] = response.headers.verify;
    }
  }

  if (pathUrl && pathUrl.indexOf("/user/login") > -1) {
    if (response.headers.certificate) {
      store.commit("SET_TOKEN_INFO", {
        certificate: response.headers.certificate
      });
    }
  }

  if (pathUrl && pathUrl.indexOf("/user/register") > -1) {
    if (response.headers.certificate) {
      store.commit("SET_TOKEN_INFO", {
        certificate: response.headers.certificate
      });
    }
  }

  tryHideFullScreenLoading();
  // 正常请求
  if (res.status === 200 || res.code === 20000) return response;

  if (response.config.responseType == "blob") return response;

  // 用户信息失效
  if ([401, 512, 20011].indexOf(res.status) > -1) {
    errorArr.push(res.status);
    if (errorArr.length > 1) return;
    store.dispatch("logOut", true);
    MessageBox.confirm(
      i18n.t("minerHome.loginHintMore"),
      i18n.t("home.hint"),
      {
        confirmButtonText: i18n.t("minerHome.goLogin"),
        cancelButtonText: i18n.t("calculator.cancel"),
        type: "warning"
      }
    )
      .then(async () => {
        errorArr = [];
        router.push({ path: `/login?type=login`, query: { redirect: router.currentRoute.fullPath } });
      })
      .catch(() => {
        errorArr = [];
      });
  }

  if (res.status === 20013) {
    const { data } = res;
    // 打印异常信息
    Notification({
      title: i18n.t("home.hint"),
      type: "error",
      message: i18n.t("errorText.the_miner_rig_is_used", { name: data.name, time: data.expirationTime })
    });

    return response
  }

  const ErrorList = [500, 20003, 20004, 20005, 20006, 20008, 20009, 20010];

  let messages = i18n.t("errorText." + (res.msg || res.message));
  if (ErrorList.indexOf(res.status) > -1) {
    messages = i18n.t("errorText.system_busy");
  }

  // 打印异常信息
  Notification({
    title: i18n.t("home.hint"),
    type: "error",
    message: messages || "error"
  });

  return response
}, err => {
  tryHideFullScreenLoading();
  setTimeout(() => {
    if (needLoadingRequestCount === 0) {
      return Promise.reject(err || err.message)
    }
  }, 300);
})

/**
 * @param  {string} url
 * @param  {object} params={}
 */
const fetch = (url, params = {}, headers = {}) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params, headers
    }).then(res => {
      resolve(res && res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @param  {string} url
 * @param  {object} data={}
 */
const post = (url, data = {}, headers = {}) => {
  return new Promise((resolve, reject) => {
    axios.post(url, data, { headers: headers }).then(res => {
      resolve(res && res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @param  {string} url
 * @param  {object} data={}
 */
const put = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(res => {
      resolve(res && res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * @param  {string} url
 * @param  {object} params={}
 */
const del = (url) => {
  return new Promise((resolve, reject) => {
    axios.delete(url, {}).then(res => {
      resolve(res && res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export { axios, url, fetch, post, put, del }


// WEBPACK FOOTER //
// ./src/http/base.js